module.exports = __webpack_public_path__ + "img/line_0_1_1.aaa4dee2.png";